import _ from 'lodash';
import { MyPrivilege } from '../reducers/myPrivilegesReducer';

export const getMyPrivileges = (state: {}): MyPrivilege[] => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-ps-generic.myPrivileges`,
    [],
  );
};
